import { CSSProperties, cloneElement, ReactElement, FC, useContext, useEffect } from "react";
import { Avatar, Divider, Dropdown, MenuProps, Space, Typography, theme } from "antd"

import { COLORS } from "../../../../../../../config/themes/colors";

import './index.css';
import { AuthContext } from "../../../../../../contexts";
import { UserInformation } from "../../../../../../interfaces";

interface UserAvatarProps {
    items: MenuProps['items'];
}

export const UserAvatar: FC<UserAvatarProps> = ({ items }) => {
    const { Paragraph } = Typography;
    const { token: { colorWhite, colorBgElevated, borderRadiusLG, boxShadowSecondary } } = theme.useToken();
    const authContext = useContext(AuthContext);
    const user = authContext.userInfo as UserInformation;


    const contentStyle: CSSProperties = {
        backgroundColor: colorBgElevated,
        borderRadius: borderRadiusLG,
        boxShadow: boxShadowSecondary,
    };
    
    const menuStyle: CSSProperties = {
        boxShadow: 'none',
    };

    const versionStyle: CSSProperties = { 
        padding: 8, 
        paddingRight: 10, 
        paddingBottom: 4, 
        textAlign: "right", 
        fontSize: '0.7rem'
    };

    useEffect(() => {
        if (user?.intermediarioPrincipal && user.cn) {
            (items as { label: JSX.Element }[])[0].label = (
                <a
                    href={`${process.env.PUBLIC_URL}/usuario/datos-productor`}
                    rel="noopener noreferrer"
                >
                    {user?.intermediarioPrincipal?.nombreInter} - {user?.intermediarioPrincipal?.codigoInter}
                </a>
            );
        }
    }, [user])


    return (
        <Space 
            className="container-avatar-dropdown"
        >
            <Dropdown
                arrow
                menu={{ items }}
                trigger={['click']}
                dropdownRender={(menu) => (
                    <div style={contentStyle}>
                        { cloneElement(menu as ReactElement, { style: menuStyle }) }
                        <Divider style={{ margin: 0 }} />
                        <Paragraph italic={true} type="secondary" style={versionStyle} >
                                v{ process.env.REACT_APP_VERSION }
                        </Paragraph>
                    </div>
                )}
            >
                <Avatar 
                    style={{ backgroundColor: colorWhite , color: COLORS.neutrals[100]}}
                >
                    { `${user?.cn?.toUpperCase().substring(0,2)}` }
                </Avatar>
            </Dropdown>  
        </Space>
    )
}
